import { Select } from '@dixa/lib-shared-habla';
import { useCallback, useMemo } from 'react';

import { useScheduleContext } from 'components/settings/components/sections/openingHours/views/schedule/schedule.context';
import type { AnnouncementItem } from 'components/shared/announcementPicker/adapters/announcementAdapter';

type SelectItem = {
  id: AnnouncementItem['url'];
  name: AnnouncementItem['label'];
};

type Props = {
  placeholder?: string;
  selectedAudio?: AnnouncementItem;
  onSelect: (announcement: AnnouncementItem) => void;
};

export function AnnouncementSelect({
  placeholder = 'No audio selected',
  selectedAudio,
  onSelect,
}: Props): JSX.Element {
  const { announcements } = useScheduleContext();
  const isLoading = !announcements;

  const items = useMemo<SelectItem[]>(
    () =>
      announcements?.map(({ url, label }) => ({
        id: url,
        name: label,
      })) || [],
    [announcements],
  );

  const handleItemSelect = useCallback(
    (item: SelectItem) => {
      const selectedItem = announcements?.find(({ url }) => url === item?.id);

      if (selectedItem) {
        onSelect(selectedItem);
      }
    },
    [announcements, onSelect],
  );

  return (
    <Select
      placeholder={isLoading ? 'Loading...' : placeholder}
      items={items}
      dropdownProps={{ fixed: true }}
      selectedItems={
        selectedAudio
          ? [{ id: selectedAudio.url, name: selectedAudio.label }]
          : []
      }
      onSelect={handleItemSelect}
      disabled={isLoading}
      searchable
    />
  );
}
